import axios, { AxiosRequestConfig, AxiosPromise } from "axios";
import { flaskReqErrorHandler, gatewayReqErrorHandler } from "./decorators";

interface ReqOptions {
  /** Show message in the FlashMessage component */
  showMessage?: boolean;
  /** Success message to display in the FlashMessage component */
  message?: string;
}

class FlaskReqClass {
  constructor(config: AxiosRequestConfig, options?: ReqOptions) {
    return FlaskReqClass.request(config, options);
  }

  @flaskReqErrorHandler
  static request(config, _options) {
    const requestConfig = config;
    if (config?.headers) {
      requestConfig.headers = {"Cache-Control": "no-cache", ...config.headers}
    }

    return axios(requestConfig);
  }
}

class GatewayReqClass {
  constructor(config: AxiosRequestConfig, options?: ReqOptions) {
    return GatewayReqClass.request(config, options);
  }

  @gatewayReqErrorHandler
  static request(config, _options) {
    const requestConfig = config;
    requestConfig.headers = {
      ...config.headers
    };

    return axios(requestConfig);
  }
}

export function FlaskReq<Response = any>(
  config: AxiosRequestConfig,
  options?: {
    /** Show message in the FlashMessage component */
    showMessage?: boolean;
    /** Success message to display in the FlashMessage component */
    message?: string;
  }
) {
  return new FlaskReqClass(config, options) as AxiosPromise<Response>;
}

export function GatewayReq<Response = any>(
  config: AxiosRequestConfig,
  options?: {
    /** Show message in the FlashMessage component */
    showMessage?: boolean;
    /** Success message to display in the FlashMessage component */
    message?: string;
  }
) {
  return new GatewayReqClass(config, options) as AxiosPromise<Response>;
}
